import { captureError } from './errorTracking';

export function toError(error: unknown): Error {
  if (error instanceof Error) {
    return error;
  }
  if (typeof error === 'string') {
    return new Error(error);
  }
  if (error && typeof error === 'object' && 'message' in error) {
    return new Error(String(error.message));
  }
  return new Error(String(error));
}

export function tryCatch<T>(fn: () => T, onError?: (error: Error) => void): T | undefined {
  try {
    return fn();
  } catch (error) {
    const err = toError(error);
    (onError ?? captureError)(err);
    return undefined;
  }
}

export async function tryCatchP<T>(
  fn: () => Promise<T>,
  onError?: (error: Error) => void
): Promise<T | undefined> {
  try {
    return await fn();
  } catch (error) {
    const err = toError(error);
    (onError ?? captureError)(err);
    return undefined;
  }
}
